<template>
  <modal
    v-if="$modal"
    class="modal"
    :class="{
      'modal_hide-page': hidePage
    }"
    name="dialog"
    :click-to-close="!hidePage"
    :pivotY="0.1"
    :width="300"
    height="auto"
    overlayTransition=""
    @before-open="beforeOpen"
    @opened="opened"
    @closed="closed"
  >
    <div class="text">
      <span v-html="text?.trim()"></span>

      <input
        v-if="input"
        ref="input"
        v-model="value"
        type="text"
        class="input"
      />
    </div>
    <div v-if="yesOrNo" class="buttons">
      <button class="g-button g-button_primary" @click.prevent="cancel">
        {{ $t("NO") }}
      </button>
      <button class="g-button g-button_primary" @click.prevent="ok">
        {{ $t("YES") }}
      </button>
    </div>
    <div v-else class="buttons">
      <button v-if="!isAlert" class="g-button" @click.prevent="cancel">
        {{ $t(cancelText) }}
      </button>
      <button class="g-button g-button_primary" @click.prevent="ok">
        {{ $t(okText) }}
      </button>
    </div>
  </modal>
</template>

<script>
export default {
  data() {
    return {
      text: '',
      cancelText: '',
      okText: '',
      input: false,
      value: '',
      rejected: true,
      isAlert: false,
      yesOrNo: false,
      validate: null,
      hidePage: false,
      closeManually: false,
    };
  },
  methods: {
    cancel() {
      this.rejected = true;
      if (this.closeManually) {
        this.fullfil();
      } else {
        this.$modal.hide('dialog');
      }
    },
    ok() {
      if (typeof this.validate === 'function') {
        const isValid = this.validate(this.value);
        if (!isValid) {
          return;
        }
      }

      this.rejected = false;
      if (this.closeManually) {
        this.fullfil();
      } else {
        this.$modal.hide('dialog');
      }
    },
    beforeOpen(event) {
      this.rejected = true;
      this.value = '';
      this.text = event.params.text;
      this.cancelText = event.params.cancelText;
      this.okText = event.params.okText;
      this.isAlert = event.params.isAlert;
      this.yesOrNo = event.params.yesOrNo;
      this.validate = event.params.validate;
      this.value = event.params.value;
      this.input = event.params.input;
      this.hidePage = event.params.hidePage;
      this.closeManually = event.params.closeManually;
      this.resolve = event.params.resolve;
      this.reject = event.params.reject;
    },
    opened() {
      if (this.input) {
        this.$refs.input.focus();
      }
    },
    closed() {
      if (this.closeManually) {
        return;
      }

      this.fullfil();
    },
    fullfil() {
      if (this.rejected) {
        this.reject();
        return;
      }

      if (this.input) {
        this.resolve(this.value);
        return;
      }

      this.resolve(true);
    },
    resolve() {},
    reject() {},
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.modal {

  &::v-deep {
    .vm--modal {
      background-color: var(--bg);
      border: 2px solid var(--lighter-primary);
    }

    .vm--overlay {
      background: rgba(0, 0, 0, var(--modal-overlay-opacity));
    }

    em {
      font-size: 0.9em;
      line-height: 1.2em;
      display: inline-block;
      margin-top: 4px;
    }
  }

  &_hide-page {
    &::v-deep {
      .vm--overlay {
        background: var(--bg);
      }
    }
  }
}

.text {
  padding: 15px 15px 10px;
  white-space: pre-line;
}

.buttons {
  display: flex;
  padding: 10px 15px 15px;
  border-top: 1px solid var(--tertiary-accent);

  button:last-child {
    margin-left: auto;
  }
}

.input {
  display: block;
  border: 1px solid var(--tertiary-accent);
  background-color: var(--tertiary-bg);
  color: var(--text-primary);
  border-radius: 2px;
  padding: 6px;
  font-size: 14px;
  margin-top: 5px;
  width: 100%;

  @include notebook {
    font-size: 16px;
  }
}
</style>
